// compare to business microservice/Resources/Cases/ListSlugs.cs
export enum Lists {
    None = "none",
    DonorsChartAudit = "chart-audit",
    DonorsFlaggedForms = "flagged-forms",
    DonorsIncomingRecovered = "incoming-recovered-tissues",
    DonorsInitialReview = "initial-review",
    DonorsPendingFinalSignoff = "pending-final-signoff",
    DonorsPendingFollowUp = "pending-follow-up",
    DonorsPendingSerologies = "pending-serologies",
    DonorsQaAutopsy = "qa-autopsy",
    DonorsQaInitial = "qa-initial",
    DonorsQaFinal = "qa-final",
    DonorsRecoveriesPending = "pending-recoveries",
    InvoicesReadyForQbo = "invoices-ready-for-qbo",
    InvoicesFlagged = "invoices-flagged",
    OrdersOpen = "orders-open",
    OrdersShippingToday = "orders-shipping-today",
    ReferralsActive = "active-ref",
    ReferralsHbov = "ref-hbov",
    ReferralsNew = "new-ref",
    ReferralsPendingDfsRn = "ref-dfs-rn",
    ScleraCleared = "sclera-cleared",
    ScleraQuarantined = "sclera-quarantined",
    ShipmentsExternal = "shipments-external",
    ShipmentsRecoveredTissues = "shipments-recovered-tissues",
    ShipmentsSatelliteTransfers = "shipments-satellite-transfers",
    ShipmentsToBeShipped = "shipments-to-be-shipped",
    SurgeriesNew = "new-surgeries",
    SurgeriesRescheduled = "rescheduled-surgeries",
    SurgeriesCancelled = "cancelled-surgeries",
    SurgeriesForDate = "surgeries-for-date",
    SurgeriesUnfilled = "unfilled-surgeries",
    TissuesCleared = "cleared-tissue",
    TissuesIncomingOmars = "incoming-omars",
    TissuesReadyToInvoice = "tissue-ready-to-invoice",
    TissuesNotReadyToInvoice = "tissue-not-ready-to-invoice",
    TissuesPendingAcceptance = "tissue-pending-acceptance",
    TissuesReturning = "tissue-returning",
    TissuesToBeGraded = "tissue-to-be-graded",
    TissuesUpcomingProcessing = "upcoming-processing",
    TissuesStored = "tissue-stored",
    TissuesResearch = "tissue-research",
}

export enum ListTypes {
    Donor = "donor",
    Invoice = "invoice",
    Order = "order",
    Procedure = "procedure",
    Referral = "referral",
    Shipment = "shipment",
    Surgery = "surgery",
    Tissue = "tissue",
    Unknown = "",
}

export const referralLists = [
    Lists.ReferralsActive,
    Lists.ReferralsHbov,
    Lists.ReferralsNew,
    Lists.ReferralsPendingDfsRn,
];

export const tissueLists = [
    Lists.TissuesCleared,
    Lists.TissuesIncomingOmars,
    Lists.TissuesReadyToInvoice,
    Lists.TissuesNotReadyToInvoice,
    Lists.TissuesPendingAcceptance,
    Lists.TissuesReturning,
    Lists.TissuesToBeGraded,
    Lists.TissuesUpcomingProcessing,
    Lists.TissuesStored,
    Lists.TissuesResearch,
];

export const isReferralList = (listSlug: string | undefined) => referralLists.includes(listSlug as Lists);
export const isTissueList = (listSlug: string | undefined) => tissueLists.includes(listSlug as Lists);
